import { render, staticRenderFns } from "./TimeslotCollectionStatsModal.vue?vue&type=template&id=fb60c210&"
import script from "./TimeslotCollectionStatsModal.vue?vue&type=script&lang=js&"
export * from "./TimeslotCollectionStatsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports